<template>
  <FloatingMenu
    v-if="isAdmin"
    ref="floatingMenu"
    :offset="[-10, 14]"
    @show="isMenuVisible = true"
  >
    <template #activator>
      <button
        class="inline-flex items-center gap-x-1 text-sm font-semibold text-gray-900"
        @click.stop="openMenu"
      >
        <div
          class="bg-light-neutral-500 rounded-full h-[30px] w-[30px] flex items-center justify-center text-mid-neutral-500"
        >
          <EllipsisHorizontalIcon class="size-6" aria-hidden="true" />
        </div>
      </button>
    </template>
    <template #content>
      <div class="flex flex-col text-dark-neutral-500 w-[200px]" @click.stop="">
        <RenameReviewModal :review-series="reviewSeries" :project="project" />
        <LockReview v-if="isMenuVisible" :review-series="reviewSeries" />
        <CreateReviewUpdate :review-series="reviewSeries" />
        <RollbackReviewSeriesModal
          v-if="reviewSeries.reviews.length > 1"
          :review-series="reviewSeries"
          :project="project"
        />
        <DeleteReviewSeriesModal
          :review-series="reviewSeries"
          :project="project"
        />
      </div>
    </template>
  </FloatingMenu>
</template>

<script lang="ts" setup>
import FloatingMenu from '@app/components/Global/FloatingMenu.vue'
import { computed, onMounted, ref, nextTick } from 'vue'
import EllipsisHorizontalIcon from '@app/components/Icons/EllipsisHorizontalIcon.vue'
import { Role } from '@core/domain/types/role.type'
import { injectStrict } from '@app/utils/injectStrict'
import { AuthKey } from '@app/injectionKeys'
import { Project } from '@core/domain/models/project.model'
import RenameReviewModal from './RenameReviewModal.vue'
import CreateReviewUpdate from './CreateReviewUpdate.vue'
import RollbackReviewSeriesModal from './RollbackReviewSeriesModal.vue'
import LockReview from './LockReview.vue'
import DeleteReviewSeriesModal from './DeleteReviewSeriesModal.vue'

const props = defineProps<{
  reviewSeries: {
    id: string
    name: string
    order: string | null
    reviews: {
      id: number
      createdAt: Date
      isLocked: boolean
    }[]
  }
  project: Project
}>()
const { user } = injectStrict(AuthKey)
const isMenuVisible = ref(false)
const shouldRender = ref(false)
onMounted(() => {
  nextTick(async () => {
    const element = document.querySelector(`#project-${props.project.id}`)!
    const callback: IntersectionObserverCallback = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(element)
      shouldRender.value = true
    }
    const observer = new IntersectionObserver(callback)
    observer.observe(element)
  })
})

const isAdmin = computed(() => user.value?.role === Role.ADMIN)
const floatingMenu = ref()

async function openMenu() {
  floatingMenu?.value?.show()
}
</script>
